<sc-master-detail [data]="stationGroups" [selection]="[selectedStationGroup]" [readOnly]="true"
    (selectionChanged)="onSelectionChanged($event);">
    <app-structure-group-details [stationGroup]="selectedStationGroup" [context]="selectionContext"></app-structure-group-details>
</sc-master-detail>